<template lang="html">
  <div :style="stylechat" class="layout-page">
    <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card>
      <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pa-0"
          @click="reCheck_consent()"
        >
          <v-icon class="fz-30">mdi-chevron-left</v-icon>
        </v-col>
        <v-col
          cols="8"
          justify="center"
          align="center"
          class="pa-0"
        >
          <span class="tab-title">{{$t('RightSide.header.privatepolicy')}}</span>
        </v-col>
        <v-col cols="2"></v-col>
      </v-layout>
      <v-card-text class="layout-page">
        <iframe style="visibility: visible; justify-content: center; align-items: center; width: 100%; height: 100vh;" frameborder='0' :src="url_consent" allow="geolocation"></iframe>
      </v-card-text>
    </v-card>
    <Warning :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
    <ErrorAlert :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
</div>
</template>

<script>
import { Decode } from '@/services'
import Warning from '@/components/Alert/Warning'
import ErrorAlert from '@/components/Alert/Error'
export default {
  props: {
    // ConsentDialog: Boolean,
    // ConsentDetail: {},
    // url_consent: String
  },
  data () {
    return {
      url_consent: '',
      share_token: '',
      tokenuser: '',
      data_user: {},
      publicPath: process.env.VUE_APP_BASE_PATH,
      DetailConsentDialog: false,
      NoteDetail: {},
      EditConsentDialog: false,
      CreatedConsentDialog: false,
      ListBottomMenu: false,
      ListBottomItem: [],
      ErrorDialog: false,
      ErrorDialogDetail: {},
      WarningDialog: false,
      WarningDialogDetail: {},
      list_note: [],
      status_edit: 'start',
      progress: false,
      stylechat: {
        "--Consent-HeaderColor": "white",
        "--Consent-TabBackground": "white",
        "--Consent-Icon": "gray",
        "--Consent-IconActive": "#2662ae",
        "--Consent-Background": "white",
        "--Consent-FontSize": "18px",
        "--Consent-FontSize-Title": "24px",
        "--Consent-FontColor": "back",
        "--Consent-FontSize-Status": "16px",
        "--Consent-FontColor-Status": "grey",
        "--Consent-Background-Input": "#E2E1E3",
        "--Consent-Color-Button": "#EFF2FE",
        "--Consent-FontColor-Button": "#2662ae",
        "--Consent-FontColor-Block-Button": "#cb1002",
        "--Consent-FontColor-Dis-Button": "#e2e1e3",
        "--Consent-Btn-Confirm-Background": "#2662ae",
        "--Consent-Btn-Confirm-Color": "white",
        "--Consent-Btn-Confirm-FontSize": "18px",
        "--Consent-Btn-Cancel-Background": "white",
        "--Consent-Btn-Cancel-Color": "#2662ae",
        "--Consent-Btn-Cancel-FontSize": "18px",
        "--Consent-Btn-Leave-Background": "white",
        "--Consent-Btn-Leave-Color": "#ff5252",
        "--Consent-Btn-Leave-FontSize": "18px",
        "--Consent-FontSize-Title-Edit": "20px"
      },
    }
  },
  components: {
    Warning,
    ErrorAlert
  },
  watch: {
  },
  created () {
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
    this.tokenuser = this.data_user.tokenuser
    this.dataConsent = JSON.parse(Decode.decode(this.$route.query.data_consent))
    this.getAccesstoken()
  },
  methods: {
    getAccesstoken () {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_ALPINE + `/api/v1/getAccesstoken`, {
        tokenuser: this.tokenuser,
        url: ''
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.share_token = response.data.data.url
          this.check_consent(response.data.data.url)
        } else if (response.data.status === 'fail') {
          this.progress = false
          if (response.data.message === 'Autherization fail.') {
            // this.$swal({
            //   text: "ขออภัย autherization ของคุณหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
            //   type: "warning",
            //   showCancelButton: false,
            //   showConfirmButton: true,
            //   confirmButtonColor: '#3085d6',
            //   confirmButtonText: 'ตกลง'
            // }).then(result => {
            //   if (result) {
            //     this.dialogLogin = true
            //   }
            // })
            this.WarningDialogDetail = {
              title: '',
              text: 'ขออภัย autherization ของคุณหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
              detail: '',
              index: '',
              type: 'consent'
            }
            this.WarningDialog = true
          } else if (response.data.message === 'not found account') {
            // this.$swal({
            //   text: "ขออภัย ไม่พบข้อมูลผู้ใช้ในระบบ กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
            //   type: "warning",
            //   showCancelButton: false,
            //   showConfirmButton: true,
            //   confirmButtonColor: '#3085d6',
            //   confirmButtonText: 'ตกลง'
            // }).then(result => {
            //   if (result) {
            //     this.dialogLogin = true
            //   }
            // })
            this.WarningDialogDetail = {
              title: '',
              text: 'ขออภัย ไม่พบข้อมูลผู้ใช้ในระบบ กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
              detail: '',
              index: '',
              type: 'consent'
            }
            this.WarningDialog = true
          }
        } else {
          this.progress = false
          this.$router.push('/listchat')
        }
      }).catch(error => {
        this.progress = false
        console.log(error)
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    reCheck_consent () {
      this.progress = true
      this.axios.post(this.dataConsent.endpoint, {
        tax_id: this.dataConsent.tax_id,
        shared_token: this.share_token,
        service_id: this.dataConsent.service_id,
        consent_form_id: this.dataConsent.consent_form_id
      }).then((response) => {
        if (response.data.result === 'success') {
          this.progress = false
          this.url_consent = ''
          if (response.data.data.status !== 'approved') {
            this.url_consent = response.data.data.response.elements.choice.url + this.share_token
            this.$router.push('/listchat')
          } else {
            this.updateConsent(this.dataConsent.bot_id)
            this.$router.push('/chat/' + this.$route.params.tokenroom)
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    check_consent (token) {
      // console.log(token)
      this.progress = true
      this.axios.post(this.dataConsent.endpoint, {
        tax_id: this.dataConsent.tax_id,
        shared_token: token,
        service_id: this.dataConsent.service_id,
        consent_form_id: this.dataConsent.consent_form_id
        // consent_form_id: null
      }).then((response) => {
        if (response.data.result === 'success') {
          this.progress = false
          this.url_consent = ''
          if (response.data.data.status !== 'approved') {
            this.url_consent = response.data.data.response.elements.choice.url + token
            // console.log(response.data.data)
            // this.$router.push('/listchat')
          } else {
            this.updateConsent(this.dataConsent.bot_id)
            this.$router.push('/chat/' + this.$route.params.tokenroom)
          }
        }
      }).catch(error => {
        console.log(error)
        if (error.response.data.error === "Cannot read property 'consent_form' of null") {
          // this.getAccesstoken()
          this.check_consent(token)
        } else {
          // console.log(error.response.data)
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
          this.$router.push('/listchat')
        }
      })
    },
    updateConsent (botid) {
      this.axios.post(process.env.VUE_APP_API_ALPINE + '/api/v1/update-consent-bot', {
        bot_id: botid,
        tokenuser: this.tokenuser
      }).then((response) => {
        // update consent
        // console.log(`update consent: ${response.data.staus}`)
      }).catch(error => {
        console.log(error)
      })
    },
    date (timestamp) {
      if (this.$cookie.get('language') === 'th') {
        return Momenttime.dayjsdatethai(timestamp)
      } else {
        return Momenttime.dayjsdateen(timestamp)
      }
    },
    time (timestamp) {
      if (this.$cookie.get('language') === 'th') {
        return Momenttime.dayjstimethai(timestamp)
      } else {
        return Momenttime.dayjstimethai(timestamp)
      }
    },
    close () {
      this.$emit('closeComponents', {
        name: 'Consent',
        value: false
      })
    },
    emitWarning (item) {
      // console.log(item)
      this.WarningDialog = false
      // if (item.type === 'delete-note') {
      // }
    },
    closeAlertDialog (data) {
      // console.log(data)
      if (data.type === 'warning') {
        this.WarningDialog = data.value
      } else if (data.type === 'err') {
        this.ErrorDialog = data.value
      } else if (data.type === 'bottommenu') {
        this.ListBottomMenu = data.value
      }
    },
  }
}
</script>

<style lang="css" scoped>
.font-list-title {
  font-weight: 600;
  color: var(--Consent-FontColor) !important;
}
.width-100 {
  width: 100% !important;
}
.fz-30 {
  font-size: 30px !important;
}
.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--Consent-FontSize-Title) !important;
  color: var(--Consent-FontColor) !important;
  font-weight: 600;
}
.text-title-edit {
  font-size: var(--Consent-FontSize-Title-Edit) !important;
  color: var(--Consent-FontColor) !important;
}
.tab-title {
  color: var(--Consent-FontColor) !important;
  font-size: var(--Consent-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--Consent-FontColor-Status) !important;
  font-size: var(--Consent-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
.checkbox-color {
  color: var(--Consent-IconActive) !important;
}
>>>.v-application .elevation-10 {
  box-shadow: none !important;
}
>>>.theme--light.v-sheet {
  box-shadow: none !important;
}
.list-overflow {
  height: calc(100vh - 64px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow::-webkit-scrollbar {
  width: 3px;
}

.list-overflow::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

.list-overflow-select {
  height: calc(100vh - 210px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow-select::-webkit-scrollbar {
  width: 3px;
}

.list-overflow-select::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}
/* >>>.v-input__slot {
  background-color: var(--Consent-Background-Input) !important;
  border-radius: 10px !important;
} */
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
  background-color: var(--Consent-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  /* overflow-y: auto; */
  top: 0;
  left: 0;
  overflow: hidden;
}
>>>.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.icon-color-edit {
  color: var(--Consent-Icon) !important;
}
.icon-color {
  color: var(--Consent-IconActive) !important;
}
.btn-confirm {
  background-color: var(--Consent-Btn-Confirm-Background) !important;
  color: var(--Consent-Btn-Confirm-Color) !important;
  font-size: var(--Consent-Btn-Confirm-FontSize) !important;
  font-weight: 600;
}
.btn-cancel {
  background-color: var(--Consent-Btn-Cancel-Background) !important;
  color: var(--Consent-Btn-Cancel-Color) !important;
  font-size: var(--Consent-Btn-Cancel-FontSize) !important;
  font-weight: 600;
}
.btn-leave {
  background-color: var(--Consent-Btn-Leave-Background) !important;
  color: var(--Consent-Btn-Leave-Color) !important;
  font-size: var(--Consent-Btn-Leave-FontSize) !important;
  font-weight: 600;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.layout-page {
  /* height: calc(100vh - 64px) !important; */
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--Consent-Background) !important;
}

.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--Consent-FontSize-Title) !important;
  color: var(--Consent-FontColor) !important;
  font-weight: 600;
}
.tab-title {
  color: var(--Consent-FontColor) !important;
  font-size: var(--Consent-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--Consent-FontColor-Status) !important;
  font-size: var(--Consent-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
</style>
